import type { SettingDto } from 'api/src/core/schemas/SettingSchema';
import ApiHttpClient from './ApiHttpClient';

export default class Settings {
  constructor(private readonly client: ApiHttpClient) {}

  async getAllSettings(): Promise<SettingDto[]> {
    return this.client.get(`v1/admin/settings`);
  }

  async updateSetting(setting: SettingDto) {
    return this.client.put(`v1/admin/settings/${setting.id}`, setting.value, {
      headers: { ContentType: 'text/plain' },
    });
  }
}
